import { type SentryAttachment } from "../types/sentry-attachment";

export function createSentryAttachment(
  filename: string,
  data: ArrayBuffer,
): SentryAttachment {
  return {
    data: new Uint8Array(data),
    filename,
  };
}
